type Props = {
  size?: number;
};

export default function CriteriaNotConfiguredIcon({ size = 32 }: Props) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} fill='none' viewBox='0 0 34 33'>
      <path
        stroke='#7c39ed'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M24.466 31.4a8.533 8.533 0 1 0 0-17.067 8.533 8.533 0 0 0 0 17.067M24.467 18.6v8.534M20.2 22.867h8.534M7.4 1.533h21.333M7.4 10.067h21.333M7.4 18.6h4.266'
      />
      <path stroke='#7c39ed' strokeWidth='2' d='M1.533 10.6a.533.533 0 0 1 0-1.067' />
      <path
        stroke='#7c39ed'
        strokeWidth='2'
        d='M1.532 10.6a.533.533 0 1 0 0-1.067M1.533 19.134a.533.533 0 1 1 0-1.067'
      />
      <path
        stroke='#7c39ed'
        strokeWidth='2'
        d='M1.532 19.134a.533.533 0 1 0 0-1.067M1.533 2.067a.533.533 0 0 1 0-1.067'
      />
      <path stroke='#7c39ed' strokeWidth='2' d='M1.532 2.067a.533.533 0 0 0 0-1.067' />
    </svg>
  );
}
